import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';
import { Product } from '@services/product/types/product';
import { Action } from 'redux';
import { PaymentFrequency } from '@services/product/types/payment-frequency';
import { Coupon } from '../../../../../services/product/types/coupon';

export class GetProducts implements LoadingAction {
  readonly type = actions.GET_PRODUCTS;
  readonly isLoading = true;
}

export class GetProductsSuccess implements LoadingAction {
  readonly type = actions.GET_PRODUCTS_SUCCESS;
  readonly isLoading = false;

  constructor(public list: Product[], public coupons: Coupon[]) {}
}

export class GetProductsError implements ErrorAction {
  readonly type = actions.GET_PRODUCTS_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export class GetProductsExtraFeatures implements LoadingAction {
  readonly type = actions.GET_PRODUCTS_EXTRA_FEATURES;
  readonly isLoading = true;
}

export class GetProductsSuccessExtraFeatures implements LoadingAction {
  readonly type = actions.GET_PRODUCTS_SUCCESS_EXTRA_FEATURES;
  readonly isLoading = false;

  constructor(public productsExtraFeatures: any) {}
}

export class GetProductsErrorExtraFeatures implements ErrorAction {
  readonly type = actions.GET_PRODUCTS_ERROR_EXTRA_FEATURES;
  readonly isError = true;

  constructor(public code: string) {}
}

export class ProductSelected implements Action {
  readonly type = actions.PRODUCT_SELECTED;

  constructor(public product: Product, public frequency: PaymentFrequency) {}
}

export type ProductsActions =
  | GetProducts
  | GetProductsSuccess
  | GetProductsError
  | GetProductsExtraFeatures
  | GetProductsSuccessExtraFeatures
  | GetProductsErrorExtraFeatures
  | ProductSelected;
